import React from 'react';
import { NavLink } from 'react-router-dom';
import '../CSS/navbar.css';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n'; // Import the i18n instance
import DarkMode from '../DarkMode/DarkMode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Navbar = ({ isDark, toggleTheme, changeLanguage }) => {
  const { t } = useTranslation();

  const handleLanguageChange = (lng) => {
    changeLanguage(lng);
    i18n.changeLanguage(lng); // Ensure i18n is defined
    toast.success(t('language_changed_message'), {
      position: "top-right",
      autoClose: 2000,
      closeOnClick: true,
      pauseOnHover: false,
    });
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand">
          <NavLink to="/" end>{t('🟡 RAMSWAROOP PATEL')}</NavLink>
        </div>
        <div className="navbar-links">
          <NavLink to="/" end>{t('home')}</NavLink> |
          <NavLink to="/resume">{t('resume')}</NavLink> |
          <NavLink to="/projects">{t('projects')}</NavLink> |
          <NavLink to="/contact">{t('contact')}</NavLink> |
          <NavLink to="/About-rpx">{t('aboutme')}</NavLink> 
        </div>
        <div className="navbar-controls">
          <select
            onChange={(e) => handleLanguageChange(e.target.value)}
            className="language-select"
            id="language-select"
            value={i18n.language}
          >
            <option value="en">English</option>
            <option value="hi">Hindi</option>
            <option value="ma">MARWADI</option>
            <option value="ta">Tamil</option>
            <option value="ja">Japanese</option>
            <option value="es">Spanish</option>
            <option value="fr">French</option>
            <option value="de">German</option>
            <option value="it">Italian</option>
            <option value="te">Telugu</option>
            <option value="kn">Kannada</option>
            <option value="ml">Malayalam</option>
            <option value="as">Assamese</option>
            <option value="bn">Bengali</option>
            <option value="gu">Gujarati</option>
            <option value="mr">Marathi</option>
            <option value="or">Odia</option>
            <option value="pa">Punjabi</option>
            <option value="ur">Urdu</option>
            <option value="ne">Nepali</option>
            <option value="ko">Korean</option>
            <option value="ru">Russian</option>
          </select>
          <DarkMode isDark={isDark} toggleTheme={toggleTheme} />
        </div>
      </nav>
      <div className='mobile-brand'>
          <div className="navbar-brand">
              <NavLink to="/" end>{t('🟡 RAMSWAROOP PATEL')}</NavLink>
          </div>
      </div>
      <nav className="bottom-nav">
        <a href="/">
          <i className="nav-icon">🏠</i>
          {t('home')}
         </a>
       <a href="/resume">
       <i className="nav-icon">📝</i>
       {t('resume')}
</a>
        <a href="/projects">
          <i className="nav-icon">💼</i>
          {t('projects')}
          </a>
        <a href="/contact">
          <i className="nav-icon">✉️</i>
          {t('contact')}
        </a>
        <a href="/About-rpx">
          <i className="nav-icon">👨‍💻</i>
          {t('aboutme')}
        </a>

      </nav>
      <ToastContainer />
    </>
  );
};

export default Navbar;